module.exports = __webpack_public_path__ + "static/media/TITAN-IRON.4ac98fff.png";